import { ConversationMetadata } from 'types/ai.types';
import { Transaction } from 'types/transactions.types';
import { useSetAiMetadata } from '.';

export const mapTransactionMetadata = (
  transaction: Partial<Transaction>,
): ConversationMetadata => ({
  documentId: transaction?._id,
  documentType: 'transaction',
  data: {
    amount: transaction.amount,
    counterPartyName: transaction.counterPartyName,
    currency: transaction.currency,
    communication: transaction.communication,
    type: transaction.transactionType,
    date: transaction.executionDate
      ? String(transaction.executionDate).split('T')[0]
      : '',
  },
});

export const useTransactionAiMetadata = (
  transaction?: Partial<Transaction>,
): void => useSetAiMetadata(transaction, 'transaction', mapTransactionMetadata);
